<main class="root-container">
  <diana-header></diana-header>
  <section class="page">
    <div class="page-content">
      <router-outlet></router-outlet>
    </div>
  </section>
  <diana-loader></diana-loader>
</main>
